import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-interaction-audit',
  templateUrl: './interaction-audit.component.html',
  styleUrls: ['./interaction-audit.component.scss'],
})
export class InteractionAuditComponent implements OnInit {
  public closeEvent: EventEmitter<any> = new EventEmitter();
  constructor(
    public bsModalRef: BsModalRef,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}
  interactionDetails: any = null;
  surveyDetails: any = null;

  selectedForm;
  selectedType;
  userData: any = {};
  recordingPageNo = 1;
  recordingStatus: boolean = true;
  interactionDetailStatus: boolean = false;
  auditStatus: boolean = true;
  userInformationStatus: boolean = false;
  callOpeningStatus: boolean = false;
  callHandlingStatus: boolean = false;
  effectiveCommunicationStatus: boolean = false;
  criticalErrorStatus: boolean = false;
  serviceDeskStatus: boolean = false;

  ngOnInit() {
    if (this.interactionDetails.UserData) {
      this.userData = JSON.parse(this.interactionDetails.UserData);
    }
    this.selectedForm = this.surveyDetails[0];
    this.selectedForm.Types = [
      {
        ID: 4,
        Name: 'Evaluation',
        Description: 'The survey is feedback/evaluation from manager.',
        ShortName: '',
        AbbreviatedName: '',
      },
    ];
  }

  closeModal() {
    this.closeEvent.emit();
  }
  changeFormField() {
    this.selectedForm.Types = [
      {
        ID: 4,
        Name: 'Evaluation',
        Description: 'The survey is feedback/evaluation from manager.',
        ShortName: '',
        AbbreviatedName: '',
      },
    ];

    //alert("test11::"+JSON.stringify(this.selectedForm.Types))
  }
  changeTypeField() {}
}
